import { pageIdInfos } from '@/Providers'

export const StatusBarExpandedPagePath = new Set<string>([
  pageIdInfos.move_log.url,
  pageIdInfos.move_log_insight.url,
  pageIdInfos.step_counter.url,
  pageIdInfos.step_counter_terms_withdrawal.url,
])
